<modal-layout-right (close)="close()"
  #contentContainer>
  <ng-container ngProjectAs="[modalTitle]">
    @if (hasEditableOptions) {
      <h3 class="h3"
      >{{ 'Create your bundle' | translate }}</h3>
    }
    @if (!hasEditableOptions) {
      <h3 class="h3"
      >{{ 'Included in this bundle' | translate }}</h3>
    }
  </ng-container>

  <ng-container ngProjectAs="[modalBody]">
    <div class="p-a-5">
      <p class="m-t p-b p1 col-11"
      *iCms="'description' of content; skipEmpty: true"></p>

      <product-bundle-options-list class="w-12"
        [product]="data.product"
        [buyRequest]="buyRequest"
        [selection]="bundleSelection"
      (selectionChange)="detectChanges()"></product-bundle-options-list>
    </div>
  </ng-container>

  <ng-container ngProjectAs="[modalFooter]">
    <div class="flex flex-middle p-a-5"
      *ifNotTradeStore>
      <div class="no-wrap p-r">
        <price class="m-r-2 s1 price"
          [class.col-6]="orgPrice"
        [value]="price"></price>
        @if (orgPrice) {
          <price class="p2 col-12 line-through price"
            [value]="orgPrice"
          ></price>
        }
      </div>

      @if (product) {
        <product-bundle-options-add-to-basket class="w-8 flex-grow"
          [product]="product"
          [buyRequest]="buyRequest"
          [gtmAddToCartVia]="EGtmAddToCartVia.bundle"
          [qty]="qty"
          (success)="close()"
        ></product-bundle-options-add-to-basket>
      }
    </div>

  </ng-container>
</modal-layout-right>
